type Message = { type: 'gameRoundStarted' } | { type: 'gameRoundEnded' };

const ALLOWED_ORIGINS = [
    'https://dummy-operator.goosicorn.dev',
    'https://dummy-operator.goosicorn.com',
    'https://mrq.com',
    'https://app.mrq-test.com',
];

export function postMessageToParent(message: Message) {
    const isInIframe = window.self !== window.top;

    if (isInIframe) {
        ALLOWED_ORIGINS.forEach((origin) => parent.postMessage(message, origin));
    }

    window.postMessage(message, '*');
}
